import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    padding: 0 16px 20px 16px;
  }
`;

export const ProductBanner = styled.div`
  width: 100%;
  max-width: 1150px;
  background-color: var(--white);
  border-radius: 12px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
  gap: 24px;
  border: 1px solid var(--light-gray);

  @media (max-width: 768px) {
    flex-direction: row;
    padding: 12px 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    gap: 16px;
    text-align: left;
  }
`;

export const ProductThumbnail = styled.div`
  width: 200px;
  height: 120px;
  background: linear-gradient(135deg, #1f1f1f 0%, #121212 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -50%;
    width: 200%;
    height: 100%;
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(255, 255, 255, 0.05) 50%,
      transparent 100%
    );
    transform: rotate(30deg);
  }

  img {
    width: 120px;
    filter: brightness(0) invert(1);
  }

  @media (max-width: 768px) {
    width: 80px;
    height: 50px;
    border-radius: 6px;

    img {
      width: 50px;
    }
  }
`;

export const ProductTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: var(--dark-gray);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 1150px;
  padding: 40px 80px;
  border-radius: 12px;
  background: var(--white);
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 2;

  @media (max-width: 1000px) {
    padding: 0; /* Remove double edge borders on mobile */
    background: transparent;
    box-shadow: none;
    border-radius: 0;
  }
`;

export const StepperContainer = styled.div`
  display: flex;
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 32px;
  box-shadow: inset 0px 2px 5px rgba(0,0,0,0.05);

  @media (max-width: 1000px) {
    margin-bottom: 24px;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
  }
`;

export const StepTab = styled.div<{ active: boolean; completed: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  transition: all 0.3s ease;
  color: ${({ active, completed }) => (active || completed ? "var(--fixit)" : "#9e9e9e")};
  background-color: ${({ active }) => (active ? "var(--white)" : "transparent")};

  ${({ active }) => active && `
    box-shadow: 0px 4px 15px rgba(0,0,0,0.05);
    z-index: 2;
    border-radius: 8px;
  `}

  .step-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    margin-right: 12px;
    color: var(--white);
    background-color: ${({ active, completed }) => (active || completed ? "var(--fixit)" : "#bdbdbd")};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    font-size: 11px;
    padding: 8px 4px;
    background-color: transparent;
    box-shadow: none;
    border-bottom: 3px solid ${({ active, completed }) => (active || completed ? "var(--fixit)" : "transparent")};
    border-radius: 0;

    .step-circle {
      width: 28px;
      height: 28px;
      font-size: 12px;
      margin-right: 0;
    }
  }
`;

export const ChangeLanguageContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
`;





export const PriceSelect = styled.select`
  font-size: 16px;
  padding: 4px 10px;
  background: var(--white);
  color: var(--dark-gray);
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 6px;
  direction: rtl;

  display: none;
  align-items: center;
  justify-content: center;

  option {
    color: var(--dark-gray);
    font-size: 16px;
  }
`;

export const IconWrapper = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  font-size: 24px;
  color: #333;
  margin: 0 0 10px;
`;

export const Message = styled.p`
  font-size: 16px;
  color: #555;
  line-height: 1.6;
  margin: 0;
`;

export const Actions = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;

  /* Estiliza o botão se ele não tiver um estilo próprio */
  & > button, & > a {
    min-width: 180px;
  }
`;
